import {
  FETCH_TENANT_LIST,
  TENANT_LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  CREATE_TENANT,
  REGISTER_TENANT,
  TENANT_CREATED,
  UPDATE_TENANT,
  TENANT_UPDATED,
  TOGGLE_LOADING,
  SHOW_TENANT_BALANCE_DIALOG,
  SHOW_TENANT_CREDIT_DIALOG,
  SHOW_RECHARGE_BALANCE_DIALOG,
  FETCH_STAFF_CONVS,
  STAFF_CONVS_FETCHED
} from './actionTypes'

export const fetchTenantList = params => ({
  type: FETCH_TENANT_LIST,
  payload: {
    params
  }
})

export const tenantListFetched = result => ({
  type: TENANT_LIST_FETCHED,
  payload: result
})

export const fetchStaffConvs = params => ({
  type: FETCH_STAFF_CONVS,
  payload: {
    params
  }
})

export const staffConvsFetched = result => ({
  type: STAFF_CONVS_FETCHED,
  payload: result
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const createTenant = data => ({
  type: CREATE_TENANT,
  payload: data
})

export const registerTenant = data => ({
  type: REGISTER_TENANT,
  payload: data
})

export const tenantCreated = data => ({
  type: TENANT_CREATED,
  payload: data
})

export const updateTenant = (id, data) => ({
  type: UPDATE_TENANT,
  payload: { id, data }
})


export const tenantUpdated = (id, data) => ({
  type: TENANT_UPDATED,
  payload: { id, data }
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const showBalanceDialog = params => ({
  type: SHOW_TENANT_BALANCE_DIALOG,
  payload: { params }
})

export const showCreditDialog = params => ({
  type: SHOW_TENANT_CREDIT_DIALOG,
  payload: { params }
})

// t端充值弹出框
export const showRechargeDialog = params => ({
  type: SHOW_RECHARGE_BALANCE_DIALOG,
  payload: { params }
})

